import { render, staticRenderFns } from "./CompanyDataUpdateTaskLevel4.vue?vue&type=template&id=0c7310ed&scoped=true&"
import script from "./CompanyDataUpdateTaskLevel4.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateTaskLevel4.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateTaskLevel4.vue?vue&type=style&index=0&id=0c7310ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7310ed",
  null
  
)

export default component.exports